import { render } from "./RulerImage.vue?vue&type=template&id=6974a47c"
const script = {}
script.render = render

export default script